import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';
import SVG from '@atlaskit/icon/svg';
import { aiThemeTokens } from '../ai-prism/constants';

/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */

var bounce = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(0);\n  }\n\n  // 200ms of 1200ms = 16.67%\n  16.67% {\n    transform: translateY(-2px);\n  }\n\n  // 400ms of 1200ms = 33.33%\n  33.33% {\n    transform: translateY(0px);\n  }\n"])));
var BASE_DELAY = 400;
var QUEUE_DELAY = 200;
var animationStyles = css({
  animation: "".concat(bounce, " 1.2s linear infinite normal")
});
var firstDelayStyles = css({
  animationDelay: "".concat(BASE_DELAY + QUEUE_DELAY, "ms")
});
var secondDelayStyles = css({
  animationDelay: "".concat(BASE_DELAY + QUEUE_DELAY * 2, "ms")
});
var thirdDelayStyles = css({
  animationDelay: "".concat(BASE_DELAY + QUEUE_DELAY * 3, "ms")
});

/**
 * this icon is theme agnostic, no need for tokens
 */
var AIIconLoading = function AIIconLoading(props) {
  return jsx(SVG, props, jsx("circle", {
    css: [animationStyles, firstDelayStyles],
    cx: "6",
    cy: "12",
    r: "1.5",
    fill: aiThemeTokens.blue700
  }), jsx("circle", {
    css: [animationStyles, secondDelayStyles],
    cx: "12",
    cy: "12",
    r: "1.5",
    fill: aiThemeTokens.blue600
  }), jsx("circle", {
    css: [animationStyles, thirdDelayStyles],
    cx: "17.5",
    cy: "12",
    r: "1.5",
    fill: aiThemeTokens.blue500
  }));
};
export default AIIconLoading;